import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import {
	DecimalToFixed,
	FormatAmount,
	TrimTime,
	FormatTransactionNumber,
} from "../../utils/helper";
import Barcode from "react-barcode";

const tdStyle = { direction: "ltr" };

function Header(props) {
	let headerText;
	let headerSubText;

	headerText = <b>Receipt / إيصال </b>;
	if (props.data.serviceId == 15) {
		headerSubText = <b>Cash In to Account / قبض نقدي لحساب </b>;
	} else if (props.data.serviceId == 19) {
		headerSubText = <b>Cash Out from Account / دفع نقدي من حساب </b>;
	}
	else if (props.data.serviceId == 28) {
		headerSubText = <b>Qi Card Cash In / إيداع نقدي - كي-كارد </b>;
	}
	else if (props.data.serviceId == 29) {
		headerSubText = <b>Qi Card Cash Out / سحب نقدي - كي-كارد </b>;
	}
	else if (props.data.serviceId == 30) {
		headerSubText = <b>APS Cash In / إيداع نقدي - شركة العرب </b>;
	}
	else if (props.data.serviceId == 31) {
		headerSubText = <b>APS Cash Out / سحب نقدي - شركة العرب </b>;
	}
	else if (props.data.serviceId == 32) {
		headerSubText = <b>POS Cash In / إيداع نقدي - مصرف الطيف </b>;
	}
	else if (props.data.serviceId == 33) {
		headerSubText = <b>POS Cash Out / سحب نقدي - مصرف الطيف </b>;
	}
	else if (props.data.serviceId == 35) {
		headerSubText = <b>TOTERS Cash In / إيداع نقدي توترز </b>;
	}
	else if (props.data.serviceId == 38) {
		headerSubText = <b>Bulk Buy / شراء العملة بالجملة </b>;
	}
	else if (props.data.serviceId == 40) {
		headerSubText = <b>Cross Hub Cash In / إيداع نقدي - بين المركزين </b>;
	}
	else if (props.data.serviceId == 41) {
		headerSubText = <b>Cross Hub Cash Out / سحب نقدي - بين المركزين </b>;
	}
	else if (props.data.serviceId == 44) {
		headerSubText = <b>Integrated TOTERS Cash In / دمج إيداع نقدي توترز </b>;
	}
	else if (props.data.serviceId == 25) {
		headerSubText = <b>Cash In-Transit Send / النقد في الطريق - إرسال</b>;
	}
	else if (props.data.serviceId == 26) {
		headerSubText = <b>Cash In-Transit Receive / النقد في الطريق - استلام</b>;
	}

	let ReprintCode = <td width='30%' align='right' valign='middle'></td>;

	if (props.iscopy) {
		ReprintCode = (
			<td width='30%' align='right' valign='middle'>
				<p>
					<span className='w-25 text-start'>Reprint:</span>
					<span className='w-50 text-center'> {props.data.currentDate}</span>
					<span className='w-25 text-end'>:إعادة طباعة</span>
				</p>
			</td>
		);
	}

	return (
		<>
		<table width='100%' className='header'>
			<tbody>
				<tr>
					<td width='30%' align='left'>
						<p className='mb-0'>
							<span className='w-75 d-inlineblock valign-middle'>
								<Barcode
									value={props.data.transactionNumber}
									height={25}
									width={1}
									fontSize={10}
									margin={5}
								/>
							</span>
						</p>
					</td>
					<td align='center' valign='top'>
						<h4 style={{ marginTop: "10px" }}>{headerText}</h4>
						<h4 style={{ fontSize: "12px" }}>{headerSubText}</h4>
					</td>
					{ReprintCode}
				</tr>
				
			</tbody>
		</table>
		<table width='100%' className='header'>
			<tbody>
				<tr>
					<td width='49.5%' align='left'>
						<p>
							<span className='w-25 text-start'>TRN No:</span>
							<span className='w-50 text-center'>
								<b> {props.data.transactionNumber} </b>
							</span>
							<span className='w-25 text-end'>:العدد</span>
						</p>
						<p>
							<span className='w-25 text-start'>Date:</span>
							<span className='w-50 text-center'>
								<b> {props.data.transactionDate} </b>
							</span>
							<span className='w-25 text-end'>:التاريخ</span>
						</p>
					</td>
					<td width='1%' align='center' valign='top'></td>
					<td width='49.5%' align='right' valign='bottom'>
						<p>
							<span className='w-25 text-start'>Branch:</span>
							<span className='w-50 text-center'>
								<b> {props.data.branchName} </b>
							</span>
							<span className='w-25 text-end'>:الفرع</span>
						</p>
						<p>
							<span className='w-25 text-start'>Phone:</span>
							<span className='w-50 text-center'>
								<b> {props.data.branchPhone} </b>
							</span>
							<span className='w-25 text-end'>:هاتف</span>
						</p>
					</td>
				</tr>
			</tbody>
		</table>
		</>
	);
}

function ClientInfo(props) {
	let senderEnTitle = "Account";//"Client Information";
	let senderArTitle = "حساب";//"معلومات عميل";

	return (
		<tr>
			<td width='100%' className='p-0'>
				<h3>
					<span className='w-50'>{senderEnTitle}</span>
					<span className='w-50 text-right'>{senderArTitle}</span>
				</h3>
				<p>
					<span className='w-25 text-start'>Account:</span>
					<span className='w-50 text-center'>
						<b> {props.data.customerAccount} </b>
					</span>
					<span className='w-25 text-end'>:حساب</span>
				</p>
			</td>
		</tr>
	);
}
function CustomerInfo(props) {
	let senderEnTitle = "Customer Information";
	let senderArTitle = "معلومات الزبون";

	return (
		<tr>
			<td width='100%' className='p-0'>
				<h3>
					<span className='w-50'>{senderEnTitle}</span>
					<span className='w-50 text-right'>{senderArTitle}</span>
				</h3>
				<p>
					<span className='w-25 text-start'>Name:</span>
					<span className='w-50 text-center'>
						<b> {props.data.personName}</b>
					</span>
					<span className='w-25 text-end'>:الاسم</span>
				</p>
				<p>
					<span className='w-25 text-start'>Phone:</span>
					<span className='w-50 text-center'>
						<b> {props.data.personPhone} </b>
					</span>
					<span className='w-25 text-end'>:هاتف</span>
				</p>
				<p>
					<span className='w-25 text-start'>Email:</span>
					<span className='w-50 text-center'>
						<b> {props.data.personEmail} </b>
					</span>
					<span className='w-25 text-end'>:البريد الإلكتروني</span>
				</p>
			</td>
		</tr>
	);
}
function FinancialInfo(props) {
	return (
		<table width='100%' cellPadding='0' cellSpacing='0'>
			<tbody>
				<tr>
					<td width='100%' className='p-0'>
						<h3>
							<span className='w-50'>Financial Info</span>
							<span className='w-50 text-right'>المعلومات المالية</span>
						</h3>
					</td>
				</tr>
				<tr>
					<td width='100%' className='p-0'>
						<table width='100%' cellPadding='5' className='user-detail'>
							<thead>
								<tr>
									<th width='5%'>#</th>
									<th>Currency</th>
									{/* /العملة */}
									<th className='text-right'>
										Amount
										{/* /المحلية */}
									</th>
									<th className='text-right'>
										Total Fee
										{/* /الرسوم */}
									</th>
								</tr>
							</thead>
							<tbody>
								{props.data.currencyExDetailReportResponses.map(
									(item, index) => (
										<tr key={index}>
											<td>{index + 1}</td>
											<td className='w-50 text-right'>
												{item.forexCurrencyCode}
											</td>
											<td className='text-right font-bold' style={{ fontSize: "11px" }}>
												{FormatAmount(item.forexCurrency)}
											</td>
											<td className='text-right'>
												{FormatAmount(item.serviceFee + item.rounding)}
											</td>
										</tr>
									)
								)}
							</tbody>
						</table>
						{/* <table width='100%' className='totals'>
							<tbody>
								{props.data.serviceFeeBreakdownResponses.map((item, index) => (
									<tr key={index}>
										<td></td>
										<td width='40%' className='text-right'>
											{item.feeLabel}
										</td>
										<td width='20%' className='text-right'>
											<span>{item.amountText}</span>
										</td>
									</tr>
								))}
							</tbody>
						</table> */}
					</td>
				</tr>
			</tbody>
		</table>
	);
}
function Comments(props) {
	return (
		props.data.cashierComments ? (
			<table width='100%' cellPadding='0' cellSpacing='0'>
				<tbody>
					<tr>
						<td width='100%' className='p-0'>
							<h3>
								<span className='w-50'>Comments</span>
								<span className='w-50 text-right'>ملاحظات</span>
							</h3>
						</td>
					</tr>
					<tr>
						<td width='100%' className='p-0'>
							<p style={{unicodeBidi:"plaintext"}}>{props.data.cashierComments}</p>
						</td>
					</tr>
				</tbody>
			</table>
		) : null
	);
}
function Signature(props) {
	return <div></div>;
}

function FooterInfo(props) {
	return <div></div>;
}

export {
	Header,
	Signature,
	FooterInfo,
	CustomerInfo,
	ClientInfo,
	FinancialInfo,
	Comments,
};
